import { useBreakpointValue } from "@chakra-ui/react"

export const useCarouselSizeAssets = () => {
  const imageHeight =
    useBreakpointValue({
      base: 250,
      md: 400,
      lg: 440,
    }) ?? 440

  const imageWidth =
    useBreakpointValue({
      base: 351,
      md: 612,
      lg: 757,
    }) ?? 757

  return { imageWidth, imageHeight }
}
